import { render, staticRenderFns } from "./best-match.vue?vue&type=template&id=7c9be1b5&scoped=true"
import script from "./best-match.vue?vue&type=script&setup=true&lang=js"
export * from "./best-match.vue?vue&type=script&setup=true&lang=js"
import style0 from "./best-match.vue?vue&type=style&index=0&id=7c9be1b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9be1b5",
  null
  
)

export default component.exports